//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pick from 'lodash.pick';
import { getAction } from '@/api/manage';
import { queryIdTree } from '@/api/api';
import userModal from "./UserModal";
export default {
  name: 'DepartWindow',
  components: {
    userModal: userModal
  },
  data: function data() {
    return {
      checkedKeys: [],
      // 存储选中的部门id
      userId: '',
      // 存储用户id
      model: {},
      // 存储SysUserDepartsVO表
      userDepartModel: {
        userId: '',
        departIdList: []
      },
      // 存储用户id一对多部门信息的对象
      departList: [],
      // 存储部门信息
      modalWidth: 400,
      departTree: [],
      title: '操作',
      visible: false,
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      headers: {},
      form: this.$form.createForm(this),
      url: {
        userId: '/sys/user/generateUserId' // 引入生成添加用户情况下的url

      }
    };
  },
  methods: {
    add: function add(checkedDepartKeys, userId) {
      this.checkedKeys = checkedDepartKeys;
      this.userId = userId;
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.departList = [];
      this.queryDepartTree();
      this.form.resetFields();
      this.visible = true;
      this.model = Object.assign({}, record);
      var filedsVal = pick(this.model, 'id', 'userId', 'departIdList');
      this.$nextTick(function () {
        _this.form.setFieldsValue(filedsVal);
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
      this.departList = [];
      this.checkedKeys = [];
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err) {
        if (!err) {
          that.confirmLoading = true;

          if (_this2.userId == null) {
            // getAction(this.url.userId).then((res)=>{
            //   console.log(res)
            //   if(res.success){
            //     let formData = {userId:res.result,
            //     departIdList:this.departList}
            //     console.log(formData)
            //     that.$emit('ok', formData);
            //   }
            // }).finally(() => {
            //   that.departList = [];
            //   that.confirmLoading = false;
            //   that.close();
            // })
            var formData = {
              userId: '',
              departIdList: _this2.departList
            };
            that.departList = [];
            that.$emit('ok', formData);
            that.confirmLoading = false;
            that.close();
          } else {
            var _formData = {
              userId: _this2.userId,
              departIdList: _this2.departList
            };
            console.log(_formData);
            that.departList = [];
            that.$emit('ok', _formData);
            that.confirmLoading = false;
            that.close();
          }
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    // 选择部门时作用的API
    onCheck: function onCheck(checkedKeys, info) {
      this.departList = [];
      this.checkedKeys = checkedKeys.checked;
      var checkedNodes = info.checkedNodes;

      for (var i = 0; i < checkedNodes.length; i++) {
        var de = checkedNodes[i].data.props;
        var depart = {
          key: '',
          value: '',
          title: ''
        };
        depart.key = de.value;
        depart.value = de.value;
        depart.title = de.title;
        this.departList.push(depart);
      }

      console.log('onCheck', checkedKeys, info);
    },
    queryDepartTree: function queryDepartTree() {
      var _this3 = this;

      queryIdTree().then(function (res) {
        if (res.success) {
          _this3.departTree = res.result;
        }
      });
    },
    modalFormOk: function modalFormOk() {}
  }
};